"use client";

import {persistentCartApi} from "@/api/persistentCartApi";
import {CART_SHARE_UUID} from "../constants/cartShare";
import { logSafeError } from "@/utils/logSafeError";

export const  deletePersistentCart = async () => {
  // Check if we're in the browser environment
  if (typeof window === "undefined" || typeof localStorage === "undefined") {
    return;
  }

  let uuidData = null;
  try {
    const storedData = localStorage.getItem(CART_SHARE_UUID);
    uuidData = storedData ? JSON.parse(storedData) : null;
  } catch (error) {
    logSafeError("persistent-cart-uuid-parse", error);
  }

  const uuid = uuidData?.uuid;

  if (uuid) {
  await   persistentCartApi.deleteCart(uuid).catch((error) => {
      logSafeError("persistent-cart-delete", error);
    });

    try {
      localStorage.removeItem(CART_SHARE_UUID);
    } catch (error) {
      logSafeError("persistent-cart-uuid-remove", error);
    }
  }
};

export const getPersistentCartUuid = () => {
  let uuid: string | null = null;

  if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
    try {
      const storedData = localStorage.getItem(CART_SHARE_UUID);
      const uuidData = storedData ? JSON.parse(storedData) : null;
      uuid = uuidData?.uuid;
    } catch (error) {
      logSafeError("persistent-cart-uuid-parse", error);
    }
  }

  return uuid;
}
